import axios from '../configV2.js';
const resource = '/users';

export default {
    search(payload) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
        return axios.get(resource, payload);
    }
}